import firebase from '../../firebase';

export default async function getRidesSample(params) {
    return firebase.functions().httpsCallable('getExportSample')(params);
}
